<template>
  <div class="p-4">
    <h2 class="text-xl font-bold mb-4">📦 คำสั่งซื้อที่รอการตรวจสอบการชำระเงิน</h2>
    <div v-if="orders.length === 0">
      <p>ยังไม่มีคำสั่งซื้อที่อยู่ในสถานะ "รอยืนยันการชำระเงิน"</p>
    </div>
    <div v-else class="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
      <div v-for="order in orders" :key="order.order_id" class="rounded-xl p-4 shadow-md bg-white">
        <img v-if="order.slip_url" :src="order.slip_url" :alt="`Order ${order.order_id}`" class="w-100 h-100 object-cover mx-auto mb-4 rounded" />

        <div class="text-sm text-gray-700">
          <p><strong>Order ID:</strong> {{ order.order_id }}</p>
          <p><strong>วันที่:</strong> {{ formatDate(order.created_at) }}</p>
          <p class="mt-2"><strong>รายการ:</strong></p>
          <ul class="list-disc list-inside">
            <li v-for="(item, index) in order.items" :key="index">
              {{ item.title }} x {{ item.quantity }} = ฿{{ item.price }}
            </li>
          </ul>
          <p><strong>รวมทั้งหมด:</strong> ฿{{ formatPrice(order.total_price) }}</p>
        </div>

        <div class="flex justify-center gap-4 mt-4">
          <button
            @click="handleSlipApprove(order.order_id, order.user_id)"
            class="bg-green-500 text-white px-4 py-1 rounded hover:bg-green-600"
          >
            ✅ ถูกต้อง
          </button>
          <button
            @click="handleSlipReject(order.order_id, order.user_id)"
            class="bg-red-500 text-white px-4 py-1 rounded hover:bg-red-600"
          >
            🔁 กรุณาส่งใหม่
          </button>
          <button
            @click="showChat(order.user_id)"
            class="bg-blue-500 text-white px-4 py-1 rounded hover:bg-blue-600"
          >
            💬 ไปที่แชท
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import axios from 'axios';

export default {
  name: "OrderChecking",
  setup() {
    const router = useRouter();
    const orders = ref([]);

    const fetchOrders = async () => {
      try {
        const res = await axios.get(`/api/slip_checking`);
        console.log('Fetched orders:', res.data);
        orders.value = res.data;
      } catch (err) {
        console.error('Error fetching orders:', err);
      }
    };

    const formatDate = (dateStr) => {
      return new Date(dateStr).toLocaleDateString('th-TH');
    };

    const formatPrice = (price) => {
      return price ? price.toLocaleString() : '0';
    };

    const showChat = (userId) => {
      console.log("Show chat for user:", userId);
      router.push(`/chat/${userId}`);
    };

    const handleSlipApprove = async (orderId, userId) => {
      try {
        const res = await fetch(`/api/orders/${orderId}/approve-slip`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ userId }),
        });
        if (res.ok) {
          alert("ยืนยันสลิปเรียบร้อยแล้ว ✅");
          fetchOrders();
        } else {
          alert("เกิดข้อผิดพลาดในการยืนยันสลิป");
        }
      } catch (err) {
        console.error("❌ Error approving slip:", err);
      }
    };

    const handleSlipReject = async (orderId, userId) => {
      try {
        const res = await fetch(`/api/orders/${orderId}/reject-slip`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ userId }),
        });
        if (res.ok) {
          alert("ปฏิเสธสลิปเรียบร้อยแล้ว ❌");
          fetchOrders();
        } else {
          alert("เกิดข้อผิดพลาดในการปฏิเสธสลิป");
        }
      } catch (err) {
        console.error("❌ Error rejecting slip:", err);
      }
    };

    onMounted(fetchOrders);

    return {
      orders,
      formatDate,
      formatPrice,
      showChat,
      handleSlipApprove,
      handleSlipReject,
    };
  },
};
</script>
